import { Component } from '@angular/core';
import { FilterField, FilterOperator, FindOptions, Ticket } from 'src/app/models';
import { AbstractService } from 'src/app/shared/services';
import { constants } from '@app/shared/utils/constants';
import { AbstractTicketListComponent } from '../abstract-ticket-list/abstract-ticket-list.component';

@Component({
  selector: 'app-tc-ticket-list',
  templateUrl: './tc-ticket-list.component.html',
  styles: [],
  standalone: false,
})
export class TcTicketListComponent extends AbstractTicketListComponent {
  ticketsTypes = constants.ticketcenter.ticketsTypes;
  override findOptions: FindOptions = {
    orderBy: 'tickets.created_at',
    orderDirection: 'desc',
    storageKey: 'tickets-find-options',
    q: '',
    fields: [
      {
        label: 'Nº',
        sortField: 'tickets.ticket_number_teorema',
        columnClass: 'text-center',
      },
      {
        label: 'Aberto em',
        sortField: 'tickets.created_at',
      },
      // {
      //   label: 'Problema',
      // },
      {
        label: 'Responsável',
        sortField: 'responsible_users.name',
      },
      // {
      //   label: 'Executor',
      // },
      {
        label: 'Cliente',
        sortField: 'persons.name',
      },
      // {
      //   label: 'Solicitante',
      // },
      {
        label: 'Sistema',
        sortField: 'systems.description',
      },
      // {
      //   label: 'Projeto',
      // },
      {
        label: 'Desenvolvedor',
        sortField: 'developer_users.name',
      },
      // {
      //   label: 'Esf. Tec',
      // },
      // {
      //   label: 'Fase',
      // },
      // {
      //   label: 'Responsável',
      // },
      {
        label: 'Status',
        sortField: 'ticket_statuses.description',
      },
      // {
      //   label: 'Sprint',
      // },
      // {
      //   label: 'Prioridade',
      // },
      {
        label: 'Previsão',
        sortField: 'tickets.expected_date',
      },
    ],
    reset: 25,
    filters: [
      new FilterField({
        name: 'tickets.situation',
        type: 'radio',
        label: 'Situação',
        options: [
          { value: 'A', label: 'Aberto' },
          { value: 'F', label: 'Fechado' },
        ],
        value: 'A',
      }),
      new FilterField({
        name: 'date',
        key: 'tickets.created_at',
        label: 'Data de abertura',
        type: 'betweenDates',
        operator: FilterOperator.between,
      }),
      new FilterField({
        name: 'tickets.type',
        type: 'select',
        label: 'Tipo',
        options: this.ticketsTypes,
        multiple: true,
      }),
      new FilterField({
        name: 'tickets.ticket_type_id',
        type: 'select',
        label: 'Tipo chamada',
        modelName: 'ticket-types',
        bindLabel: 'description',
        bindValue: 'id',
        multiple: true,
      }),
      new FilterField({
        name: 'number',
        key: 'tickets.ticket_number_teorema',
        label: 'Número',
        type: 'text',
        operator: FilterOperator.equal,
      }),
      new FilterField({
        name: 'problem',
        key: 'tickets.problem',
        label: 'Problema',
        type: 'text',
        operator: FilterOperator.like,
      }),
      new FilterField({
        name: 'requester',
        key: 'tickets.requester',
        label: 'Solicitante',
        type: 'text',
        operator: FilterOperator.like,
      }),
      new FilterField({
        name: 'systems',
        key: 'tickets.system_id',
        label: 'Sistema',
        type: 'select',
        modelName: 'systems',
        bindLabel: 'description',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'customers',
        key: 'tickets.customer_id',
        label: 'Cliente',
        type: 'select',
        multiple: true,
        modelName: 'customers',
        bindLabel: '_name',
        bindValue: 'id',
        orderBy: 'persons.name',
      }),
      new FilterField({
        name: 'developer',
        multiple: true,
        label: 'Desenvolvedor',
        type: 'select',
        modelName: 'users',
        bindLabel: 'name',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'sprint',
        key: 'tickets.sprint_id',
        label: 'Sprint',
        type: 'select',
        modelName: 'sprints',
        bindLabel: 'description',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'phases',
        key: 'tickets.phase_id',
        label: 'Fase',
        type: 'select',
        modelName: 'phases',
        bindLabel: 'description',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'projects',
        key: 'tickets.project_id',
        label: 'Projeto',
        type: 'select',
        modelName: 'projects',
        bindLabel: 'description',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'companies',
        key: 'tickets.company_id',
        label: 'Empresa',
        type: 'select',
        modelName: 'companies',
        bindLabel: '_name',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'responsible',
        multiple: true,
        label: 'Responsável',
        type: 'select',
        modelName: 'users',
        bindLabel: 'name',
        bindValue: 'id',
      }),
      new FilterField({
        name: 'executor',
        multiple: true,
        label: 'Executor',
        type: 'select',
        modelName: 'users',
        bindLabel: 'name',
        bindValue: 'id',
      }),
    ],
  };

  override onRowClicked(ticket: Ticket) {
    this.router.navigate([`/chamados/editar/${ticket.id}`]);
  }

  override getService(): AbstractService<Ticket> {
    return this.tcTicketService;
  }

  override get openTicketRoute(): string {
    return '/chamados/novo';
  }
}
